import React from "react";
import { IonSkeletonText } from "@ionic/react";

interface SkeletonLoaderProps {
  widths: string[];
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ widths }) => {
  return (
    <div className="flex-col space-y-[7px] mt-[30px]">
      {widths.map((width, index) => (
        <IonSkeletonText key={index} animated={true} style={{ width }} />
      ))}
    </div>
  );
};

export default SkeletonLoader